import { render, staticRenderFns } from "./ComplexUnits.vue?vue&type=template&id=5b71318e&scoped=true"
import script from "./ComplexUnits.vue?vue&type=script&lang=js"
export * from "./ComplexUnits.vue?vue&type=script&lang=js"
import style0 from "./ComplexUnits.vue?vue&type=style&index=0&id=5b71318e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b71318e",
  null
  
)

export default component.exports